// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import { HomeTemplate } from '../../components/templates';
import React, { useCallback, useRef } from 'react';
import { Hero } from '../../components/organisms';
import { Button } from '../../components/atoms';
import { AiOutlineArrowDown } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { ProjectCards } from './ProjectCards';
import { Coding } from '../../assets/images';

export interface HomePageContainerProps {}

export default function HomePageContainer(_props: HomePageContainerProps) {
    // TODO move this stuff
    const cardWallRef = useRef<HTMLDivElement>(null);
    const scrollToCardWall = useCallback(() => {
        cardWallRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [cardWallRef]);

    return (
        <HomeTemplate>
            <Hero />
            {false && (
                <div className="project-indicator">
                    <Button type="text" onClick={scrollToCardWall}>
                        <span>view projects</span>
                        <AiOutlineArrowDown />
                    </Button>
                </div>
            )}
            <div className="ui-line"></div>
            {/*<FilterBar />*/}
            <ProjectCards />
            <div ref={cardWallRef} className="temporary-uh-oh-div">
                <div className="uh-oh-wrapper">
                    <Coding />
                    <p>
                        i'll keep posting here whenever i finish something cool. i'm currently
                        working on:
                    </p>
                    <ul>
                        <li>
                            updates and additions to my{' '}
                            <span className="alt">component library</span>
                        </li>
                        <li>
                            an interactive{' '}
                            <span className="alt" title="TBD">
                                pokedex widget
                            </span>
                        </li>
                        <li>
                            chapter 1 of my{' '}
                            <Link to="/looking-glass">through the looking glass</Link> text game
                        </li>
                        <li>
                            any other <span className="alt">fun projects</span> i'm working on
                        </li>
                    </ul>
                    <p>come back soon for more!</p>
                </div>
            </div>
        </HomeTemplate>
    );
}
